import { SubGameType } from "types/game";

import { CATEGORY_CODE } from "./type";
import { ProviderLogo } from "assets/desktop/images/providerList";
import { ImgProvider } from "assets/desktop/images/navSubgame";

export const listLiveCasino: SubGameType[] = [
  {
    game_code: "",
    name: "DG真人",
    provider_code: "DG",
    provider_name: "Dream Gaming",
    type: CATEGORY_CODE.LIVE_CASINO,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.LiveDG,
    icon: ProviderLogo.DG,
  },
  {
    game_code: "",
    name: "歐博真人",
    provider_code: "AB",
    provider_name: "Allbet Gaming",
    type: CATEGORY_CODE.LIVE_CASINO,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.LiveAB,
    icon: ProviderLogo.AB,
  },
  {
    game_code: "",
    name: "沙龍真人",
    provider_code: "SA",
    provider_name: "SA Gaming",
    type: CATEGORY_CODE.LIVE_CASINO,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.LiveSA,
    icon: ProviderLogo.SA,
  },
  {
    game_code: "",
    name: "WM真人",
    provider_code: "WM",
    provider_name: "WM Gaming",
    type: CATEGORY_CODE.LIVE_CASINO,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.LiveWM,
    icon: ProviderLogo.WM,
  },

  {
    game_code: "",
    name: "億博真人",
    provider_code: "YB",
    provider_name: "Yeebet Gaming",
    type: CATEGORY_CODE.LIVE_CASINO,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.LiveYB,
    icon: ProviderLogo.YB,
  },
];
